import { IBaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { KeyValuePairArray } from '../../models/KeyValuePair';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { xToastr, ToastrTypes } from '../../shared/Toastr';
import { IErrorEventArgs } from '../../models/event-args/global-error.event.args';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';

import { RemoveAdminAccessRequest } from '../../models/ss-api/requests/remove.admin.access.request';
import { ssApiService } from '@services/ss-api.service';
import { AdminPermissionTypes } from '@models/domain/admin.permission.item';
import { AdminItemArray, AdminItem } from '@models/domain/admin.item';

import { SortBot } from '../../helpers/sort';


@Component({
    selector: 'users',
	templateUrl: './users.component.html',
	styleUrls: ['./users.component.scss']
})
export class UsersComponent {

    
    IsBusy: boolean = false;

	
	Admins : AdminItemArray;


    constructor(private router: Router, private gb: GlobalService, private API: ssApiService, private sweetAlertService: SweetAlertService,) {
        // subscribe and add to list

    }

	ngOnInit() {

		this.InitUserOptions();

	}
	
	InitUserOptions() {
		
		this.IsBusy = true;
	
		let disposable = this.API.getAdmins().subscribe(response => {
			disposable.unsubscribe();
			console.log( response.Data );
			response.Data = SortBot.SortAuto<AdminItemArray>(response.Data, 'FirstName');
	
			this.IsBusy = false;
			
			this.Admins = response.Data;

		});
	
	}


	PromptRemoveAccess( admin : AdminItem ) {

		this.sweetAlertService.swal({
			title: 'Revoke Access?',
			text: 'Revoking access from ' + admin.FirstName + ' ' + admin.LastName + ' will prevent them from being able to log in to the SSDB Team panel. Do you wish to continue?',
			type: 'warning',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
			allowOutsideClick: false,
			closeButtonTextContent: 'x',
		}).then(() => {
			this.RemoveAdminAccess( admin.AdminID );
		}, () => {});

	}


    RemoveAdminAccess( adminID : number ){

        var request = new RemoveAdminAccessRequest();
        request.AdminID = adminID;

		console.log("Remove acces to user with ID: " + adminID);

		
		this.IsBusy = true;

        var subscription = this.API.RemoveAdminAccess(request).subscribe(result => {
			
            subscription.unsubscribe();
			this.IsBusy = false;

			if( result.Result ) {
				this.sweetAlertService.swal({
					title: 'Access Removed',
					text: 'The user is no longer able to access the team panel.',
					type: 'success',
					
					allowOutsideClick: false,
					closeButtonTextContent: 'x',
					timer: 2000,
				}).then(() => {
					this.InitUserOptions();
				}, () => {});
			}

            console.log("RemoveAdminAccess result = ", result);
        }, error => {
			
			this.sweetAlertService.swal({
				title: 'Error',
				text: 'There was an error processing your request, please see console log for details.',
				type: 'error',
				showCancelButton: false,
				showCloseButton: true,
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancel',
				allowOutsideClick: false,
				closeButtonTextContent: 'x',
				
			}).then(() => {}, () => {});
			

            console.log("RemoveAdminAccess ERROR :: ", error);
		});            
    }  

	

	
}
